import PropTypes from 'prop-types';
import React from 'react';
import { isEqual } from 'lodash';
import { Scrollbars } from 'shared/vendor/react-custom-scrollbars/src/index';
import Item from './item';

export default class InfiniteGrid extends React.Component {

	static get propTypes() {
		return {
			itemClassName: PropTypes.string,
			entries: PropTypes.arrayOf(PropTypes.object).isRequired,
			height: PropTypes.number,
			width: PropTypes.number,
			padding: PropTypes.number,
			marginBottom: PropTypes.number,
      marginTop: PropTypes.number,
			wrapperHeight: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.number,
			]),
			wrapperMaxHeight: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.number,
			]),
			lazyCallback: PropTypes.func,
			renderRangeCallback: PropTypes.func,
			buffer: PropTypes.number,
      getItemsPerRow: PropTypes.func,
      getImageSize: PropTypes.func,
      containerWidth: PropTypes.number,
		};
	}

	initialState() {
		return {
			initiatedLazyload: false,
			minHeight: window.innerHeight * 2,
			minItemIndex: 0,
			maxItemIndex: 100,
      gridMarginTop: 0,
			itemDimensions: {
				height: this._itemHeight(),
				width: this._itemHeight(),
				gridWidth: 0,
				itemsPerRow: 2,
			},
		};
	}

	constructor(props) {
		super(props);
		this.state = this.initialState();
		// bind the functions
		this._scrollListener = this._scrollListener.bind(this);
		this._updateItemDimensions = this._updateItemDimensions.bind(this);
		this._resizeListener = this._resizeListener.bind(this);
		this._visibleIndexes = this._visibleIndexes.bind(this);
	}

		// METHODS

	_wrapperStyle() {
		return {
			// overflowY: 'scroll',
			width: '100%',
      // maxHeight: this._getGridHeight(),
			// WebkitOverflowScrolling: true,
		};
	}

	_gridStyle() {
		return {
			position: 'relative',
			marginTop: this.props.marginTop >= 0 ? this.props.marginTop : this.props.padding,
			marginLeft: this.props.padding,
			minHeight: this._getGridHeight(),
			marginBottom: this.props.marginBottom,
		};
	}

	_getGridRect() {
		return this.refs.grid.getBoundingClientRect();
	}

	_getGridHeight() {
    let height = this.state.itemDimensions.height;
    if (this.props.constPadding) {
      height = this._itemHeight();
    }
		return (this.props.entries.length < this.state.itemDimensions.itemsPerRow) ?
			height :
      Math.ceil(this.props.entries.length / this.state.itemDimensions.itemsPerRow) * height;
	}

	_getWrapperRect() {
		return this.refs.wrapper.refs.container.getBoundingClientRect();
	}

  itemsPerRow = 0;
  pastRows = 0;

	_visibleIndexes(nextProps) {
	  const { buffer, entries } = this.props;
		const itemsPerRow = this._itemsPerRow(nextProps);
		const pastRows = this._scrolledPastRows(nextProps);
		// prevent unneeded calculation
    if(itemsPerRow === this.itemsPerRow && pastRows === this.pastRows) {
      return;
    }
		// The number of rows that the user has scrolled past
		let scrolledPast = (pastRows * itemsPerRow);
		if (scrolledPast < 0) {
		  scrolledPast = 0;
    }
    // the maximum should be the number of items scrolled past, plus some
    // buffer
    var bufferItems = this._numVisibleRows() * itemsPerRow + buffer;

		// If i have scrolled past 20 items, but 60 are visible on screen,
		// we do not want to change the minimum
		var min = scrolledPast - itemsPerRow - buffer;
		if (min < 0) min = 0;

		var max = scrolledPast + bufferItems;
		if (max > entries.length) max = entries.length;

    this.itemsPerRow = itemsPerRow;
    this.pastRows = pastRows;
    if (this.state.minItemIndex !== min || this.state.maxItemIndex !== max) {
      this.setState({
        minItemIndex: min,
        maxItemIndex: max,
      }, function() {
        this._lazyCallback();
      });
    }
	}

	_updateItemDimensions(nextProps) {
		this.setState({
			itemDimensions: {
				height: this._itemHeight(),
				width: this._itemHeight(),
				gridWidth: this.props.constPadding ? this._containerWidth(nextProps) : this._getGridRect().width,
				itemsPerRow: this._itemsPerRow(nextProps),
			},
			minHeight: this._totalRows(),
		});
	}

  _containerWidth(nextProps) {
    return nextProps && nextProps.containerWidth ? nextProps.containerWidth : this.props.containerWidth;
  }

  _itemsPerRow(nextProps) {
    const itemsPerRowLimit = this.props.itemsPerRowLimit;
    const calcCount = Math.floor(this._getGridRect().width / this._itemWidth());
    let itemsPerRow = ((itemsPerRowLimit === 0) || (calcCount < itemsPerRowLimit)) ? calcCount : itemsPerRowLimit;
    if (this.props.constPadding) {
      itemsPerRow = this.props.getItemsPerRow(this._containerWidth(nextProps));
    }
    return itemsPerRow;
  }

	_totalRows() {
		const scrolledPastHeight = (this.props.entries.length / this._itemsPerRow()) * this._itemHeight();
		if (scrolledPastHeight < 0) return 0;
		return scrolledPastHeight;
	}

	_scrolledPastRows(nextProps) {
		const rect = this._getGridRect();
    const gridMarginTop = this.state.gridMarginTop;
		const topScrollOffset = (rect.height + gridMarginTop) - rect.bottom;

		return Math.floor(topScrollOffset / this._itemHeight(nextProps));
	}

	_itemHeight(nextProps) {
		let itemHeight = this.props.height + (2 * this.props.padding);
    if (this.props.constPadding) {
      itemHeight = this.props.getImageSize(this._containerWidth(nextProps), this.props.padding) + this.props.padding;
    }
    return itemHeight;
	}

	_itemWidth() {
		return this.props.width + (2 * this.props.padding);
	}

	_numVisibleRows() {
		return Math.ceil(this._getWrapperRect().height / this._itemHeight());
	}

	_lazyCallback() {
		if (!this.state.initiatedLazyload && (this.state.maxItemIndex === this.props.entries.length) && this.props.lazyCallback) {
			this.setState({initiatedLazyload: true });
			this.props.lazyCallback(this.state.maxItemIndex);
		}
	}

	_findItemPositionHeight(index) {
		return _.floor(index / this._itemsPerRow())*(this._itemHeight());
	}

	// LIFECYCLE

	componentWillMount() {
		window.addEventListener('resize', this._resizeListener);
	}

	componentDidMount() {
		this._updateItemDimensions();
		this._visibleIndexes();
    const gridMarginTop = this._getGridRect().top;
    if (gridMarginTop > 0) {
      this.setState({ gridMarginTop });
    }
	}

	componentWillReceiveProps(nextProps) {
		const { searchItemIndex, changeSearchFile } = this.props;
		if (nextProps.searchItemIndex !== searchItemIndex && nextProps.searchItemIndex !== -1) {
			this.refs.wrapper.scrollTop(this._findItemPositionHeight(nextProps.searchItemIndex));
			changeSearchFile({ searchFile: '' });
		}
		if (nextProps.entries.length > this.props.entries.length) {
			this.setState({
				initiatedLazyload: false,
			});
		}
		// Update these all the time because entries may change on the fly.
		this._updateItemDimensions(nextProps);
		this._visibleIndexes(nextProps);
	}

	componentDidUpdate(prevProps, prevState) {
		if (typeof this.props.renderRangeCallback === 'function') {
			this.props.renderRangeCallback(this.state.minItemIndex, this.state.maxItemIndex);
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return !isEqual(this.state, nextState) || !isEqual(this.props.entries, nextProps.entries);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._resizeListener);
	}

	// LISTENERS

	_scrollListener(event) {
    this._visibleIndexes();
	}

	_resizeListener(event) {
			if (!this.props.wrapperHeight) {
					this.setState({
							wrapperHeight: window.innerHeight,
					});
			}
			this._updateItemDimensions();
			this._visibleIndexes();
	}

	// RENDER

	render() {
		var entries = [];
		// if no entries exist, there's nothing left to do
		if (!this.props.entries.length) {
			return null;
		}

		for (let i = this.state.minItemIndex; i <= this.state.maxItemIndex; i++) {
			let entry = this.props.entries[i];
			if (!entry) {
				continue;
			}
			const itemProps = {
				key: entry.props.innerkey ? entry.props.innerkey : 'item-' + i,
				index: i,
				padding: this.props.padding,
				dimensions: this.state.itemDimensions,
				data: entry,
        constPadding: this.props.constPadding,
        getImageSize: this.props.getImageSize,
			};
			entries.push(<Item {...itemProps} />);
		}
    return (
      <Scrollbars
        onScroll={this._scrollListener}
        style={this._wrapperStyle()}
        className="infinite-grid-wrapper"
        ref="wrapper"
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        universal
        viewStyle={{ overflow: 'scroll' }}
      >
        <div ref="grid" className="infinite-grid" style={this._gridStyle()}>
          {entries}
        </div>
      </Scrollbars>
    );

  }

}

InfiniteGrid.defaultProps = {
  buffer: 20,
  padding: 10,
  entries: [],
  height: 250,
  width: 250,
  marginBottom: 0,
  itemsPerRowLimit: 0,
  constPadding: false,
};